import { render } from "./WebLayout.vue?vue&type=template&id=e06d5904&scoped=true"
import script from "./WebLayout.vue?vue&type=script&lang=js"
export * from "./WebLayout.vue?vue&type=script&lang=js"

import "./WebLayout.vue?vue&type=style&index=0&id=e06d5904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e06d5904"]])

export default __exports__